import { Clickable } from 'src/shared/design-system/Utilities';
import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';
import { Colors, Font, Spacing, Transition } from 'web-common/src/shared/styles';

export const Wrapper = styled.div<{ isLight?: boolean; isLikedByUser?: boolean; hoverable?: boolean }>`
  align-items: center;
  border-radius: ${Spacing.DOUBLE};
  display: flex;
  gap: ${Spacing.HALF};
  padding: ${Spacing.QUARTER} ${Spacing.HALF};
  position: relative;
  bottom: 1px;

  &,
  & svg {
    transition: background ${Transition.Time.BASE}, color ${Transition.Time.BASE};
  }

  ${({ hoverable, isLight, isLikedByUser }) =>
    match({ isLight: !!isLight, isLikedByUser: !!isLikedByUser })
      .with(
        { isLight: true, isLikedByUser: true },
        () => css`
          background: ${Colors.BELL_PEPPER_DARK_30};
          color: ${Colors.BELL_PEPPER_LITE_10};
          cursor: default;

          & svg {
            color: ${Colors.BELL_PEPPER_LITE_10};
          }
        `
      )
      .with(
        { isLight: true, isLikedByUser: false },
        () => css`
          background: transparent;
          color: ${Colors.WHITE};

          & svg {
            color: ${Colors.WHITE};
          }
          ${hoverable &&
          `
              &:hover {
                background: ${Colors.GRAY_DARK_10};
                cursor: pointer;
              }
            `}
        `
      )
      .with(
        { isLight: false, isLikedByUser: true },
        () => css`
          background: ${Colors.BELL_PEPPER_LITE_30};
          color: ${Colors.BELL_PEPPER_DARK_10};
          cursor: default;

          & svg {
            color: ${Colors.BELL_PEPPER_DARK_10};
          }
        `
      )
      .otherwise(
        () => css`
          background: transparent;
          color: ${Colors.GRAY_DARK_10};

          & svg {
            color: ${Colors.GRAY_DARK_10};
          }
          ${hoverable &&
          `
            &:hover {
              background: ${Colors.GRAY_LITE_30};
              cursor: pointer;
            }
          `}
        `
      )};
`;

export const Button = styled(Clickable)`
  background: none;
  padding: 0;
  transition: background ${Transition.Time.BASE};
  ${Font.bySize(Font.Size.XXS)};
`;
